// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
  /* Extended color palette (10 distinct colors) */
  --c1: #2F5597;  /* Navy Blue */
  --c2: #E8743B;  /* Warm Orange */
  --c3: #19A979;  /* Green */
  --c4: #F2C80F;  /* Yellow-Gold */
  --c5: #5F6CAF;  /* Indigo */
  --c6: #D72D3A;  /* Red */
  --c7: #7F8C8D;  /* Gray */
  --c8: #8E44AD;  /* Purple */
  --c9: #27AE60;  /* Emerald Green */
  --c10: #F39C12; /* Amber */

  /* Optional: soft hues for hover effects */
  --grid-stroke: #eaeef3;
}


/* ===== Layout & panels ===== */
.dash-grid {
  display: grid;
  grid-template-columns: 1fr 1fr; /* 2 equal columns */
  grid-auto-rows: 420px;          /* height for each row (1 & 2) */
  gap: 5px;
}

/* Container 3 spans 2 columns, same height as row height above */
.panel-3 { grid-column: 1 / span 2; }

/* panel look (remove when you add the real charts) */
.panel {
  background: #ffffff;
  border: 1px solid #fff;   /* ← grey border */
  border-radius: 10px;
  padding: 12px;
}

.panel-placeholder {
  height: 100%;
  display: grid;
  place-items: center;
  color: #fff;
  background: rgba(27,93,155,.35);
  border-radius: 8px;
  font-size: 28px;
  border: 1px solid rgba(0,0,0,.15);
}

/* Make it breathe on smaller screens */
@media (max-width: 1200px) {
  .dash-grid { grid-auto-rows: 360px; }
}
@media (max-width: 900px) {
  .dash-grid {
    grid-template-columns: 1fr;  /* stack */
    grid-auto-rows: 320px;
  }
  .panel-3 { grid-column: auto; }
}

/* ===== Global distribution donut ===== */
.gd-card { height: 100%; display: flex; flex-direction: column; }
.gd-title {
  text-align: center; margin: 0 0 6px; color: #000;
  font-weight: 700; letter-spacing: .3px; font-size: 25px;
}
.gd-wrap { flex: 1 1; display: grid; grid-template-columns: 1fr 280px; gap: 40px; min-height: 0; }
.gd-chart { min-height: 0; height: 100%; } /* required for ResponsiveContainer */

.gd-total { 
  font-size: 40px;    /* number in center */
  font-weight: 700;
  fill: #000;
}
.gd-sub {
  font-size: 20px;    /* was 13px */
  font-weight: 600;   /* optional for bolder text */
  fill: #000;
}

.gd-legend { display: flex; flex-direction: column; gap: 10px; align-self: center; }
.gd-legend-row { display: flex; align-items: center; gap: 10px; }
.gd-legend-row .dot { width: 17px; height: 17px; border-radius: 50%; }
/* increase legend fonts */
.gd-legend-row .name {
  flex: 1 1;
  font-size: 20px;   /* was 14px */
}
.gd-legend-row .pct {
  font-size: 18px;   /* was about 14px */
  color: #000;
}

@media (max-width: 1100px) {
  .gd-wrap { grid-template-columns: 1fr; }
}

/* ===== Monthly bar card ===== */
.mb-card { height: 100%; display: flex; flex-direction: column; }
.mb-title {
  text-align: center; margin: 0 0 6px; color: #000;
  font-weight: 700; letter-spacing: .3px; font-size: 25px;
}
.mb-chart { flex: 1 1; min-height: 0; }

/* ===== Species yearly bar ===== */
.sy-card { height: 100%; display: flex; flex-direction: column; }
.sy-title {
  text-align: center; margin: 0 0 6px; color: #000;
  font-weight: 700; letter-spacing: .3px; font-size: 25px;
}
.sy-chart { flex: 1 1; min-height: 0; }
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/Dashboard.css"],"names":[],"mappings":";AACA;EACE,gDAAgD;EAChD,aAAa,GAAG,cAAc;EAC9B,aAAa,GAAG,gBAAgB;EAChC,aAAa,GAAG,UAAU;EAC1B,aAAa,GAAG,gBAAgB;EAChC,aAAa,GAAG,WAAW;EAC3B,aAAa,GAAG,QAAQ;EACxB,aAAa,GAAG,SAAS;EACzB,aAAa,GAAG,WAAW;EAC3B,aAAa,GAAG,kBAAkB;EAClC,cAAc,EAAE,UAAU;;EAE1B,0CAA0C;EAC1C,sBAAsB;AACxB;;;AAGA,gCAAgC;AAChC;EACE,aAAa;EACb,8BAA8B,EAAE,oBAAoB;EACpD,qBAAqB,WAAW,gCAAgC;EAChE,QAAQ;AACV;;AAEA,iEAAiE;AACjE,WAAW,uBAAuB,EAAE;;AAEpC,qDAAqD;AACrD;EACE,mBAAmB;EACnB,sBAAsB,IAAI,kBAAkB;EAC5C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA,uCAAuC;AACvC;EACE,aAAa,qBAAqB,EAAE;AACtC;AACA;EACE;IACE,0BAA0B,GAAG,UAAU;IACvC,qBAAqB;EACvB;EACA,WAAW,iBAAiB,EAAE;AAChC;;AAEA,0CAA0C;AAC1C,WAAW,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE;AAChE;EACE,kBAAkB,EAAE,eAAe,EAAE,WAAW;EAChD,gBAAgB,EAAE,oBAAoB,EAAE,eAAe;AACzD;AACA,WAAW,SAAO,EAAE,aAAa,EAAE,gCAAgC,EAAE,SAAS,EAAE,aAAa,EAAE;AAC/F,YAAY,aAAa,EAAE,YAAY,EAAE,EAAE,qCAAqC;;AAEhF;EACE,eAAe,KAAK,qBAAqB;EACzC,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,eAAe,KAAK,aAAa;EACjC,gBAAgB,IAAI,6BAA6B;EACjD,UAAU;AACZ;;AAEA,aAAa,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACnF,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAChE,sBAAsB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACrE,0BAA0B;AAC1B;EACE,SAAO;EACP,eAAe,IAAI,aAAa;AAClC;AACA;EACE,eAAe,IAAI,mBAAmB;EACtC,WAAW;AACb;;AAEA;EACE,WAAW,0BAA0B,EAAE;AACzC;;AAEA,iCAAiC;AACjC,WAAW,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE;AAChE;EACE,kBAAkB,EAAE,eAAe,EAAE,WAAW;EAChD,gBAAgB,EAAE,oBAAoB,EAAE,eAAe;AACzD;AACA,YAAY,SAAO,EAAE,aAAa,EAAE;;AAEpC,mCAAmC;AACnC,WAAW,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE;AAChE;EACE,kBAAkB,EAAE,eAAe,EAAE,WAAW;EAChD,gBAAgB,EAAE,oBAAoB,EAAE,eAAe;AACzD;AACA,YAAY,SAAO,EAAE,aAAa,EAAE","sourcesContent":["\n:root {\n  /* Extended color palette (10 distinct colors) */\n  --c1: #2F5597;  /* Navy Blue */\n  --c2: #E8743B;  /* Warm Orange */\n  --c3: #19A979;  /* Green */\n  --c4: #F2C80F;  /* Yellow-Gold */\n  --c5: #5F6CAF;  /* Indigo */\n  --c6: #D72D3A;  /* Red */\n  --c7: #7F8C8D;  /* Gray */\n  --c8: #8E44AD;  /* Purple */\n  --c9: #27AE60;  /* Emerald Green */\n  --c10: #F39C12; /* Amber */\n\n  /* Optional: soft hues for hover effects */\n  --grid-stroke: #eaeef3;\n}\n\n\n/* ===== Layout & panels ===== */\n.dash-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr; /* 2 equal columns */\n  grid-auto-rows: 420px;          /* height for each row (1 & 2) */\n  gap: 5px;\n}\n\n/* Container 3 spans 2 columns, same height as row height above */\n.panel-3 { grid-column: 1 / span 2; }\n\n/* panel look (remove when you add the real charts) */\n.panel {\n  background: #ffffff;\n  border: 1px solid #fff;   /* ← grey border */\n  border-radius: 10px;\n  padding: 12px;\n}\n\n.panel-placeholder {\n  height: 100%;\n  display: grid;\n  place-items: center;\n  color: #fff;\n  background: rgba(27,93,155,.35);\n  border-radius: 8px;\n  font-size: 28px;\n  border: 1px solid rgba(0,0,0,.15);\n}\n\n/* Make it breathe on smaller screens */\n@media (max-width: 1200px) {\n  .dash-grid { grid-auto-rows: 360px; }\n}\n@media (max-width: 900px) {\n  .dash-grid {\n    grid-template-columns: 1fr;  /* stack */\n    grid-auto-rows: 320px;\n  }\n  .panel-3 { grid-column: auto; }\n}\n\n/* ===== Global distribution donut ===== */\n.gd-card { height: 100%; display: flex; flex-direction: column; }\n.gd-title {\n  text-align: center; margin: 0 0 6px; color: #000;\n  font-weight: 700; letter-spacing: .3px; font-size: 25px;\n}\n.gd-wrap { flex: 1; display: grid; grid-template-columns: 1fr 280px; gap: 40px; min-height: 0; }\n.gd-chart { min-height: 0; height: 100%; } /* required for ResponsiveContainer */\n\n.gd-total { \n  font-size: 40px;    /* number in center */\n  font-weight: 700;\n  fill: #000;\n}\n.gd-sub {\n  font-size: 20px;    /* was 13px */\n  font-weight: 600;   /* optional for bolder text */\n  fill: #000;\n}\n\n.gd-legend { display: flex; flex-direction: column; gap: 10px; align-self: center; }\n.gd-legend-row { display: flex; align-items: center; gap: 10px; }\n.gd-legend-row .dot { width: 17px; height: 17px; border-radius: 50%; }\n/* increase legend fonts */\n.gd-legend-row .name {\n  flex: 1;\n  font-size: 20px;   /* was 14px */\n}\n.gd-legend-row .pct {\n  font-size: 18px;   /* was about 14px */\n  color: #000;\n}\n\n@media (max-width: 1100px) {\n  .gd-wrap { grid-template-columns: 1fr; }\n}\n\n/* ===== Monthly bar card ===== */\n.mb-card { height: 100%; display: flex; flex-direction: column; }\n.mb-title {\n  text-align: center; margin: 0 0 6px; color: #000;\n  font-weight: 700; letter-spacing: .3px; font-size: 25px;\n}\n.mb-chart { flex: 1; min-height: 0; }\n\n/* ===== Species yearly bar ===== */\n.sy-card { height: 100%; display: flex; flex-direction: column; }\n.sy-title {\n  text-align: center; margin: 0 0 6px; color: #000;\n  font-weight: 700; letter-spacing: .3px; font-size: 25px;\n}\n.sy-chart { flex: 1; min-height: 0; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
